// $(function(){
//     $('.slider-for').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: false,
//         fade: true,
//         asNavFor: '.slider-nav'
//     });
//     $('.slider-nav').slick({
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         asNavFor: '.slider-for',
//         dots: false,
//         arrows: true,
//         centerMode: true,
//         focusOnSelect: true
//     });
// });   

window.openFilter = function () {
    if ($('.filter-main .filterproducts').hasClass('__slideout')) {
        $('.filter-main .filterproducts').removeClass('__slideout').addClass('__slidein').show();
        $('.filter-main .filter-overlay').removeClass('hide').addClass('show').show();
    }
}
window.closeFilter = function () {
    if ($('.filter-main .filterproducts').hasClass('__slidein')) {
        $('.filter-main .filterproducts').removeClass('__slidein').addClass('__slideout').show();
        $('.filter-main .filter-overlay').removeClass('show').addClass('hide').show();
        
    }
}